// extracted by mini-css-extract-plugin
export default {"uploadButton":"FontUploadButton_uploadButton__QtUCL","button":"FontUploadButton_button__9rtY8","hiddenInput":"FontUploadButton_hiddenInput__qIOG2"};